import { combineReducers, compose, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import persistState from 'redux-localstorage'
// ---------- REDUCERS --------------------------------
import authReducer from '../store/reducers/authReducer';
import currencyReducer from '../store/reducers/currencyReducer';
import expensesReducer from './reducers/expensesReducer';
import productsReducer from '../store/reducers/productsReducer';
import salesReducer from '../store/reducers/salesReducer';
import searchReducer from '../store/reducers/searchReducer';
import userReducer from '../store/reducers/userReducer';
import notificationsReducer from './reducers/notificationsReducer';
import sellersReducer from './reducers/sellersReducer';
import inventorysReducer, { tempInventory } from './reducers/inventoryReducer';

const reducers = combineReducers({
    auth: authReducer,
    currency: currencyReducer,
    expenses: expensesReducer,
    inventorys: inventorysReducer,
    tempInventory: tempInventory,
    notifications: notificationsReducer,
    products: productsReducer,
    sales: salesReducer,
    search: searchReducer,
    sellers: sellersReducer,
    user: userReducer
});

const loggerMiddleware = createLogger({
    predicate: () => process.env.NODE_ENV === 'development',
});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares = composeEnhancers(applyMiddleware(thunk, loggerMiddleware), persistState())
// const middlewares = compose(applyMiddleware(thunk), persistState())

const store = createStore(reducers, middlewares);

export default store;